// extracted by mini-css-extract-plugin
module.exports = {"row":"_927a99ad28--row--mxoQb"};